import * as types from './question.types';
import * as constants from './question.constants';
import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

export const storeQuestion = generateStoreResourceAction<types.IQuestion>(constants.STORE_QUESTION);
export const clearQuestion = generateClearResourceAction(constants.CLEAR_QUESTION);
